import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { withRouter } from "../../../providers/withRouter";
import FiltrosComunidades from '../../../components/filtros/filtrosComunidades';
import BreadCrumb from '../../../components/navbar/Breadcrumb';
import { DataTable } from "../../../components";
import { Box, CircularProgress } from "@mui/material";
import { getFincasAAFF, getOneAAFF, sendEmailBienvenida } from "../../../services";
import { cambiarFormatoNombre, diferenciaMesesCaducidad, estadoServicio, formatoFechasEs, ventaMasReciente, GRUPOS_SERVICIO } from '../../../functions/funciones';
import { useLocation, useNavigate } from "react-router-dom";
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import { UsuarioContext } from "../../../providers/userContext";
import Swal from 'sweetalert2';
import { toast } from "react-toastify";
import ExportarComunidadesSinSenales from "../admin/ExportarComunidadesSinSenales";

const GestionComunidades = (props) => {
    const { t } = useTranslation(['properties', 'aaff', 'common']);

    const ComunidadesRows = [
        {
            id: "comunidad_name",
            numeric: false,
            disablePadding: false,
            label: t('columns.community'),
            overrideFunc: (data, row) => (
                <Link to={`/aaff/${row.nifAAFF}/comunidades/${row.nif}`}>
                    {data}
                </Link>
            ),
        },
        {
            id: "nif",
            numeric: false,
            disablePadding: false,
            label: t('columns.nif'),
        },
        {
            id: "fechaAlta",
            numeric: false,
            disablePadding: false,
            label: t('columns.registrationDate'),
        },
        {
            id: "codigoPostal",
            numeric: false,
            disablePadding: false,
            label: t('common:form.postalCode').toUpperCase(),
        },
        {
            id: "municipio",
            numeric: false,
            disablePadding: false,
            label: t('columns.municipality'),
        },
        {
            id: "provincia",
            numeric: false,
            disablePadding: false,
            label: t('common:form.province').toUpperCase(),
        },
        {
            id: "estadoCae",
            numeric: false,
            disablePadding: false,
            label: t('columns.caeStatus'),
            noObjeto:true,
            overrideFunc: (data, row) => (
              !row.isWorkcenter ?
                  <div className="activoSelect">
                      <span style={{ color: data === 1 || data == null ? "#3eae3e"  : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}>
                        {data === "-" ? data : estadoServicio(data, t)}
                      </span>
                  </div>
              : ""
            ),
        },
        {
            id: "estadoLopd",
            numeric: false,
            disablePadding: false,
            label: t('columns.lopdStatus'),
            noObjeto:true,
            overrideFunc: (data, row) => (
                !row.isWorkcenter ?
                    <div className="activoSelect">
                        <span style={{ color: data === 1 || data == null ? "#3eae3e"  : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}>
                        {data === "-" ? data : estadoServicio(data, t)}
                        </span>
                    </div>
                : ""
            ),
        },
        {
            id: "estadoCai",
            numeric: false,
            disablePadding: false,
            label: t('columns.caiStatus'),
            noObjeto:true,
            overrideFunc: (data, row) => (
                !row.isWorkcenter ?
                    <div className="activoSelect">
                        <span style={{ color: data === 1 || data == null ? "#3eae3e"  : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}>
                        {data === "-" ? data : estadoServicio(data, t)}
                        </span>
                    </div>
                : ""
            ),
        },
        {
            id: "estadoKae",
            numeric: false,
            disablePadding: false,
            label: t('columns.kaeStatus'),
            noObjeto:true,
            overrideFunc: (data, row) => (
                !row.isWorkcenter ?
                    <div className="activoSelect">
                        <span style={{ color: data === 1 || data == null ? "#3eae3e"  : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}>
                        {data === "-" ? data : estadoServicio(data, t)}
                        </span>
                    </div>
                : ""
            ),
        },
    ];
    const user = useContext(UsuarioContext);
    const {filtrosIniciales} = useRecogerURLParamsFiltros();
    const [busqueda, setBusqueda] = useState(filtrosIniciales);
    const [aaff, setAAFF] = useState({});
    const [loading, setLoading] = useState(true);
    const [recargar, setRecargar] = useState(false);
    const [limite, setLimite] = useState(0);
    const [busquedaActiva, setBusquedaActiva] = useState(false);
    const [clearFilterActivo, setClearFilterActivo] = useState(false);
    const [data, setData] = useState({
        meta: {},
        rows: [],
    });
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  }


    useEffect(() => {
        fetchData();
        //setRecargar(false)
    }, [recargar]);

    const fetchData = async ({ offset, limit, filtros = busqueda } = {}) => {
        
        construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros);

        try {
            const dats = await getOneAAFF(props.params.nif);
            setAAFF(dats);
            setLimite(limit);
            const payload = {
                filtros: { ...filtros, aaff_id: dats.id },
                params: { page: offset, limit },
            };
            const response = await getFincasAAFF(payload);
            const { meta, data } = response;
            setData({
                meta,
                rows: formatData(data),
            });
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
            setIsLoading(false); // Mover aquí para asegurarse de que se ejecute después de que los datos se hayan cargado
        }
    };

    const formatData = (data) => {
        const formattedData = [];
        console.log(data)
        data.map((row) => {
            // const diferenciaMeses = diferenciaMesesCaducidad(row.fechaRenovacion, row.createdAt)
            const sale_cae = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cae);
            const sale_lopd = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.lopd);
            const sale_cai = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cai);
            const instalacion_kae = row?.instalacionesKae?.find(i => i.prop_id === row.id) || null;
            formattedData.push({
                comunidad_name: row.razonSocial,
                nif: row.nif,
                nifAAFF: row.aaff.nif,
                fechaAlta: formatoFechasEs(row.createdAt),
                codigoPostal: row.codigoPostal,
                municipio: row.municipio,
                provincia: row.provincia,
                isWorkcenter: false,
                // caducada: diferenciaMeses > 13 ? true : false
                saleCae_id: sale_cae?.id || null,
                saleLopd_id: sale_lopd?.id || null,
                saleCai_id: sale_cai?.id || null,
                instalacionKae_id: instalacion_kae ? instalacion_kae.id : null,
                estadoCae: sale_cae ? sale_cae.estado_id === null ? 1 : sale_cae.estado_id : "-",
                estadoLopd: sale_lopd ? sale_lopd.estado_id === null ? 1 : sale_lopd.estado_id : "-",
                estadoCai: sale_cai ? sale_cai.estado_id === null ? 1 : sale_cai.estado_id : "-",
                estadoKae: instalacion_kae ? instalacion_kae.estado_id : "-",
            });
            if (row.workcenters?.length > 0) {
                row.workcenters?.forEach((wc) => {
                    formattedData.push({
                        comunidad_name: wc.razonSocial,
                        nif: "",
                        fechaAlta: "",
                        codigoPostal: "",
                        municipio: "",
                        provincia: "",
                        isWorkcenter: true,
                        estadoCae: "",
                        estadoLopd: "",
                        estadoCai: "",
                        estadoKae: "",
                        saleCae_id: "",
                        saleLopd_id: "",
                        saleCai_id: "",
                        instalacionKae_id: "",
                    });
                });
            }
        });
        return formattedData;
    };

    const handleSendEmail = async () => {
        try {
            const result = await Swal.fire({
                title: t('aaff:confirmations.sendAccessEmail'),
                text: t('aaff:confirmations.sendAccessEmailText'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#33dd75",
                cancelButtonColor: "#888",
                confirmButtonText: t('aaff:confirmations.send'),
                cancelButtonText: t('aaff:confirmations.cancel'),
            });

            if (result.isConfirmed) {
                const toastInfo = toast.info(t('aaff:confirmations.sendingAccessEmail'), { autoClose: false });
                const res = await sendEmailBienvenida(user.id, props.params.nif, aaff.razonSocial, aaff.user.email);
                if (res.status === 201) {
                    toast.update(toastInfo, { render: t('aaff:confirmations.sentSuccess'), type: toast.TYPE.SUCCESS, autoClose: true });
                } else {
                    toast.update(toastInfo, { render: t('aaff:confirmations.sendError'), type: toast.TYPE.ERROR, autoClose: true });
                }
            }
        } catch (error) {
            console.error("Error al enviar email:", error);
            toast.error(t('aaff:confirmations.sendError'));
        }
    };

    const filtrarDatos = (filtros) => {
        setBusqueda(filtros);
        setBusquedaActiva(true);
        // fetchData({ offset: 1, limit: limite, filtros });
    };

    return isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress style={{ color: '#92004D' }} />
        </div>
    ) : (
        <>
        {console.log(aaff)}
            <BreadCrumb rutas={[{ path: '/aaff', label: t('aaff:title') }, { path: '/aaff', label: `${aaff.razonSocial}` }]} style={{ margin: '0 10px' }} />
            <div className="listPage">
                <div className="gridCard">
                    <div className="gridHead">
                        {t('details.generalInfo')}
                    </div>
                    <div className="gridSubhead editarSubhead">
                        <div>{t('aaff:details.companyData')}</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div className="datosGrid" style={{ width: '75%' }}>
                            <p>
                                <b>{t('aaff:details.name')}:</b> {aaff.razonSocial}
                            </p>
                            <p>
                                <b>{t('common:form.nif')}:</b> {aaff.nif}
                            </p>
                            <p>
                                <b>{t('columns.municipality')}:</b> {cambiarFormatoNombre(aaff.municipio)}
                            </p>
                            <p>
                                <b>{t('common:form.province')}:</b> {aaff.provincia}
                            </p>
                            <p>
                                <b>{t('aaff:details.contactPerson')}:</b> {aaff.nombreContacto}
                            </p>
                            <p>
                                <b>{t('common:form.phone')}:</b> {aaff.telefono}
                            </p>
                            <p>
                                <b>{t('common:form.email')}:</b> {aaff.user?.email}
                            </p>
                            <p>
                                <b>{t('aaff:details.contactEmail')}:</b> {aaff.correoContacto}
                            </p>
                            <p>
                                <b>{t('aaff:details.technician')}:</b>{" "}
                                {(() => {
                                    const matchCae = (rel) => {
                                        if (!rel) return false;
                                        return Array.isArray(rel) ? rel.some(g => g.group_id === 1) : rel.group_id === 1;
                                    };
                                    const tecnicoCae = aaff.technicians?.find(objeto => matchCae(objeto?.r_tech_aaffs));
                                    return tecnicoCae ? (
                                        <Link onClick={() => window.location = `mailto:${tecnicoCae.user?.email}`}>
                                            {tecnicoCae.nombre + " " + tecnicoCae.apellidos}
                                        </Link>
                                    ) : "-";
                                })()}{" "}
                            </p>
                            {aaff?.gruposServicios?.includes(1) &&
                                <p>
                                    <b>{t('aaff:details.consultantCae')}:</b>{" "}
                                    <Link onClick={() => window.location = `mailto:${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 1).user?.email}`}>
                                        {aaff.consultants?.find(item => item.r_consul_servsgroups_aaffs.group_id === 1) ? `${aaff.consultants?.find(item => item.r_consul_servsgroups_aaffs.group_id === 1).nombre} ${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 1).apellidos}` : ''}
                                    </Link>
                                </p>
                            }
                            {aaff?.gruposServicios?.includes(2) &&
                                <p>
                                    <b>{t('aaff:details.consultantLopd')}:</b>{" "}
                                    <Link onClick={() => window.location = `mailto:${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 2).user?.email}`}>
                                        {aaff.consultants?.find(item => item.r_consul_servsgroups_aaffs.group_id === 2) ? `${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 2).nombre} ${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 2).apellidos}` : ''}
                                    </Link>
                                </p>
                            }
                        </div>
                    </div>
                    <div className="datosGrid">
                        <div></div>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <button onClick={() => handleSendEmail()} style={{ margin: '10px 0', borderRadius: '5px 5px', backgroundColor: '#92004D', color: '#ffffff', padding: '5px 10px' }}>
                                {t('aaff:details.sendAccessEmail')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gridSubhead editarSubhead">
                <div>{t('aaff:details.communitiesList')}</div>
            </div>
            <div className="pageContent tableContainer">
                <ExportarComunidadesSinSenales nif={aaff.nif} />
                <FiltrosComunidades onFilter={filtrarDatos} clearFilter={clearFilters}  filtrosIniciales={busqueda} />
                <div className="tableWrapper">
                    <Box className="pageContent">
                        <Box sx={{ mb: 10 }}>
                            <DataTable
                                data={data.rows}
                                isLoading={loading}
                                headers={ComunidadesRows}
                                fetcher={fetchData}
                                currentPage={data.current_page}
                                meta={data.meta}
                                totalItems={data.total}
                                totalPages={data.totalPages}
                                nextPage={data.next_page}
                                filtros={busqueda}
                                busquedaActiva={busquedaActiva}
                                setBusquedaActiva={setBusquedaActiva}
                                clearFilterActivo={clearFilterActivo}
                                setClearFilterActivo={setClearFilterActivo}
                                mensaje={t('noCommunities')}
                                // propCaducada={true}
                            />
                        </Box>
                    </Box>
                </div>
            </div>
        </>
    );
}

export default withRouter(GestionComunidades);
